import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { getDefaultWorkspaceRoute } from 'helpers/workspace';

const GuestRoute = ({ children, isAuthenticated }) => {
  const { getCurrentWorkspaceMode } = useAuth();
  return !isAuthenticated 
    ? children
    : <Navigate to={getDefaultWorkspaceRoute(getCurrentWorkspaceMode())} replace />;
};
GuestRoute.propTypes = {
  children: PropTypes.node.isRequired,
  isAuthenticated: PropTypes.bool
};

export default GuestRoute;